'use client'

import Header from '@/Components/HeaderComp'
import Footer from '@/Components/Footer'
import { usePage } from '@inertiajs/react'

export default function Theme({ children }) {
    const { bannerMessage, navigation = { categories: [], pages: [] }, footerNavigation = { products: [], company: [], customerService: [] } } = usePage().props

    return (
        <>
            <Header bannerMessage={bannerMessage} navigation={navigation} />
            {children}
            <Footer footerNavigation={footerNavigation} />
        </>
    )
}
